import PrivateListingLandingForm from './PrivateListingLandingForm.component';

export default PrivateListingLandingForm;
